/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';

import type {
	LoomEntryPointsQuery as LoomEntryPointsQuery$data,
	LoomEntryPointsQueryVariables as LoomEntryPointsQuery$variables,
} from './graphql/__types__/LoomEntryPointsQuery';

export const useIsLoomEntryPointsEnabled = (): boolean | undefined => {
	const { accessStatus, cloudId } = useSessionData();

	const shouldSkip =
		accessStatus !== AccessStatus.LICENSED_ADMIN_ACCESS &&
		accessStatus !== AccessStatus.LICENSED_USE_ACCESS;

	const { data, error, loading } = useQuery<
		LoomEntryPointsQuery$data,
		LoomEntryPointsQuery$variables
	>(
		gql`
			query useIsLoomEntryPointsEnabledQuery($cloudId: ID!) {
				confluence_loomEntryPoints(cloudId: $cloudId) {
					isLoomEntryPointsEnabled
				}
			}
		`,
		{
			variables: {
				cloudId,
			},
			skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
		},
	);

	if (window.__SSR_LOOM_ENTRY_POINT__) {
		return undefined;
	}

	if (error) {
		markErrorAsHandled(error);
		return true;
	}

	if (!loading && data) {
		return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
	}
};
